/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import ReadMoreLessHTML from "../../common/ReadMoreLessHTML";
import { deleteSettings, listSettings, getAppVersions, listSMSSettingKeys, deleteSMSSettingKey } from "./_requests";
import { useProfile } from "../../Components/Hooks/UserHooks";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useProfile();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "1");

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const [settingsPolicies, setSettingsPolicies] = useState([]);
  const [settingsMore, setSettingsMore] = useState([]);
  const [settingsKey, setSettingsKey] = useState([]);
  const [smsSettings, setSmsSettings] = useState([]);
  const [appVersions, setAppVersions] = useState<any[]>([]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [settingsToDeleteId, setSettingsToDeleteId] = useState("");
  const [settingsToDeleteName, setSettingsToDeleteName] = useState("");

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  const fetchSettings = async () => {
    try {
      const res = await listSettings();
      console.log("FULL SETTINGS RESPONSE:", res);

      if (res.data) {
        console.log("SettingsPolicies:", res.data?.SettingsPolicies);
        console.log("SettingsMore:", res.data?.SettingsMore);
        console.log("SettingsKey:", res.data?.SettingsKey);

        setSettingsPolicies(res.data.SettingsPolicies || []);
        setSettingsMore(res.data.SettingsMore || []);
        setSettingsKey(res.data.SettingsKey || []);
      }

      const smsRes = await listSMSSettingKeys();
      if (smsRes.data) {
        setSmsSettings(smsRes.data || []);
      }

      const appVersionsRes = await getAppVersions();
      if (appVersionsRes?.data) {
        setAppVersions(appVersionsRes.data || []);
      } else if (Array.isArray(appVersionsRes)) {
        setAppVersions(appVersionsRes);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };



  useEffect(() => {
    fetchSettings();
  }, []);

  const addSettings = () => {
    navigate("/settings/add");
  };

  const onClickDelete = useCallback(
    (setting: any) => {
      setSettingsToDeleteName(setting.name);
      setSettingsToDeleteId(setting.id);
      toggleDeleteModal();
    },
    [toggleDeleteModal]
  );

  const confirmDelete = async (settingId: any) => {
    await deleteSettings(settingId);
    toggleDeleteModal();
    toast.success("Settings deleted successfully", { autoClose: 3000 });
    fetchSettings();
  };
  const [visibleFields, setVisibleFields] = useState<{ [key: string]: boolean }>({});
  const toggleFieldVisibility = (rowId: string, field: string) => {
    const key = `${rowId}-${field}`;
    setVisibleFields((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const policiesColumns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Type",
        accessorKey: "settings_type",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const data = cell.getValue();
          const id = cell.row.original.id;

          // Type mapping: number to string
          const type: Record<number, string> = {
            1: "User App",
            2: "Driver App",
          };

          // Use type[data] safely, with a fallback value in case data is not found
          const label = type[data] || "Unknown"; // Default to "Unknown" if no match

          return <Link to={`/settings/view/${id}`}>{label}</Link>;
        }


      },
      {
        header: "Terms and Conditions",
        accessorKey: "terms_and_condition",
        cell: (cell: any) => <ReadMoreLessHTML html={cell.getValue() || "-"} />,
      },
      {
        header: "Privacy Policy",
        accessorKey: "privacy_policy",
        cell: (cell: any) => <ReadMoreLessHTML html={cell.getValue() || "-"} />,
      },
      {
        header: "Cancellation Policy",
        accessorKey: "cancellation_policy",
        cell: (cell: any) => <ReadMoreLessHTML html={cell.getValue() || "-"} />,
      },
      {
        header: "About",
        accessorKey: "about",
        cell: (cell: any) => <ReadMoreLessHTML html={cell.getValue() || "-"} />,
      },
    ],
    []
  );
  const handleEditMore = (rowData: any) => {
    const id = rowData.id; // Make sure `id` exists in your row data
    navigate(`/settings/editmore/${id}`);
  };
  const basicSettingsDetails = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Morning Time",
        accessorKey: "slot_morning_time",
        cell: (cell: any) => (cell.getValue() ? cell.getValue() : "-"),
      },
      {
        header: "Evening Time",
        accessorKey: "slot_evening_time",
        cell: (cell: any) => (cell.getValue() ? cell.getValue() : "-"),
      },
      {
        header: "Expiry Reminder (Days)",
        accessorKey: "expiry_reminder",
        cell: (cell: any) => (cell.getValue() ? cell.getValue() : "-"),
      },
      {
        header: "Action",
        id: "action",
        cell: (cellProps: any) => (
          <i
            className="ri-edit-box-line text-blue-600 cursor-pointer"
            onClick={() => handleEditMore(cellProps.row.original)}
            title="Edit"
          />
        ),
      },
    ],
    []
  );

  const handleEditCompany = (rowData: any) => {
    const id = rowData.id;
    navigate(`/settings/company/${id}`);
  };

  const companySettingsColumns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Company Name",
        accessorKey: "name",
      },
      {
        header: "Email",
        accessorKey: "email",
      },
      {
        header: "Mobile",
        accessorKey: "mobile_number",
      },
      {
        header: "GST No",
        accessorKey: "gst_no",
        cell: (cell: any) => cell.getValue() || "-",
      },
      {
        header: "Bank Name",
        accessorKey: "bank_name",
        cell: (cell: any) => cell.getValue() || "-",
      },
      {
        header: "Action",
        id: "action",
        cell: (cellProps: any) => (
          <i
            className="ri-edit-box-line text-blue-600 cursor-pointer"
            onClick={() => handleEditCompany(cellProps.row.original)}
            title="Edit Company Details"
          />
        ),
      },
    ],
    []
  );

  const handleEditKey = (rowData: any) => {
    const id = rowData.id; // Make sure `id` exists in your row data
    navigate(`/settings/editkey/${id}`);
  };
  const handleEditSMSSettingsKey = (rowData: any) => {
    const id = rowData.id; // Make sure `id` exists in your row data
    navigate(`/settings/edit-sms-key/${id}`);
  };
  const settingsKeyColumns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Type",
        accessorKey: "is_razorpay_mode_status",
        cell: (cell: any) => {
          const value = cell.getValue();
          const typeMap = {
            1: { label: "Test", color: "#facc15", textColor: "#92400e" },  // yellow
            2: { label: "Live", color: "#43d578ff", textColor: "#166534" },  // green
          };

          const { label, color, textColor } =
            typeMap[value as 1 | 2] || {
              label: "Unknown",
              color: "#e5e7eb",
              textColor: "#374151",
            };

          return (
            <span
              style={{
                backgroundColor: color,
                color: textColor,
                padding: "4px 10px",
                borderRadius: "999px",
                fontSize: "14px",
                fontWeight: 900,
              }}
            >
              {label}
            </span>
          );
        },
      },

      {
        header: "Public Key",
        accessorKey: "test_razorpay_public_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-test_razorpay_public_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "test_razorpay_public_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Secret Key",
        accessorKey: "test_razorpay_secret_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-test_razorpay_secret_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "test_razorpay_secret_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        header: "Public Key (Live)",
        accessorKey: "live_razorpay_public_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-live_razorpay_public_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "live_razorpay_public_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Secret Key(Live)",
        accessorKey: "live_razorpay_secret_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-live_razorpay_secret_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "live_razorpay_secret_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Map Key",
        accessorKey: "google_map_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-google_map_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "google_map_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Send Grid Key",
        accessorKey: "send_grid_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-send_grid_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "send_grid_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Abstract Email Key",
        accessorKey: "abstract_email_api_key",
        cell: (cell: any) => {
          const key = `${cell.row.id}-abstract_email_api_key`;
          const isVisible = visibleFields[key];
          const value = cell.getValue();

          return value ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{isVisible ? value : "••••••••••"}</span>
              <i
                className={`ri-eye${isVisible ? "-off" : ""}-line cursor-pointer`}
                onClick={() => toggleFieldVisibility(cell.row.id, "abstract_email_api_key")}
                title={isVisible ? "Hide" : "Show"}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        header: "Action",
        id: "action",
        cell: (cellProps: any) => (
          <i
            className="ri-edit-box-line text-blue-600 cursor-pointer"
            onClick={() => handleEditKey(cellProps.row.original)}
            title="Edit"
          />
        ),
      },
    ],
    [visibleFields]
  );

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const smsSettingsColumns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Type",
        accessorKey: "type",
        cell: (cell: any) => (cell.getValue() === 1 ? "OTP" : "Order"),
      },
      {
        header: "SMS Gateway Key",
        accessorKey: "sms_gateway_key",
      },
      {
        header: "Sender",
        accessorKey: "sms_gateway_sender",
      },
      {
        header: "Template Id",
        accessorKey: "sms_gateway_template_id",
      },
      {
        header: "Action",
        id: "action",
        cell: (cellProps: any) => (
          <div className="hstack gap-2">
            <i
              className="ri-pencil-fill text-primary cursor-pointer"
              onClick={() => navigate(`/settings/sms-setting/edit/${cellProps.row.original.id}`)}
              title="Edit"
            />
            <i
              className="ri-delete-bin-fill text-danger cursor-pointer"
              onClick={() => {
                setSettingsToDeleteName(`SMS Setting (${cellProps.row.original.type === 1 ? 'OTP' : 'Order'})`);
                setSettingsToDeleteId(cellProps.row.original.id);
                setDeleteType('sms');
                toggleDeleteModal();
              }}
              title="Delete"
            />
          </div>
        ),
      },
    ],
    []
  );

  const [deleteType, setDeleteType] = useState<'policy' | 'sms'>('policy');

  const confirmDeleteAction = async () => {
    if (deleteType === 'sms') {
      await deleteSMSSettingKey(settingsToDeleteId);
      toast.success("SMS Setting deleted successfully", { autoClose: 3000 });
    } else {
      await deleteSettings(settingsToDeleteId);
      toast.success("Settings deleted successfully", { autoClose: 3000 });
    }
    toggleDeleteModal();
    fetchSettings();
  };

  const handleEditAppVersion = (rowData: any) => {
    const id = rowData.id;
    navigate(`/settings/app-version/edit/${id}`);
  };

  const appVersionColumns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "App Type",
        accessorKey: "app_type",
        cell: (cell: any) => {
          const type = cell.getValue();
          return type === 1 ? "User App" : type === 2 ? "Driver App" : "Unknown";
        },
      },
      {
        header: "Platform",
        accessorKey: "platform",
        cell: (cell: any) => {
          const platform = cell.getValue();
          return platform === 1 ? "Android" : platform === 2 ? "iOS" : "Unknown";
        },
      },
      {
        header: "Min Version",
        accessorKey: "min_version",
      },
      {
        header: "Latest Version",
        accessorKey: "latest_version",
      },
      {
        header: "Force Update",
        accessorKey: "force_update",
        cell: (cell: any) => {
          const forceUpdate = cell.getValue();
          return (
            <span
              className={`badge bg-${forceUpdate === 1 ? "success" : "danger"}-subtle text-${forceUpdate === 1 ? "success" : "danger"
                }`}
            >
              {forceUpdate === 1 ? "Enabled" : "Disabled"}
            </span>
          );
        },
      },
      {
        header: "Action",
        id: "action",
        cell: (cellProps: any) => (
          <i
            className="ri-edit-box-line text-blue-600 cursor-pointer"
            onClick={() => handleEditAppVersion(cellProps.row.original)}
            title="Edit"
          />
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Settings" pageTitle="Paal Dappa" />
          <Card>
            <CardHeader>
              <Row>
                <Col sm="6">
                  <h5 className="card-title mb-0">Settings</h5>
                </Col>
                <Col sm="6" className="text-end">
                  <Button
                    color="primary"
                    onClick={addSettings}
                  >
                    <i className="ri-add-line align-bottom me-1"></i> Add Settings
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <Nav tabs className="nav-tabs-custom">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                >
                  Policies
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  Slot Timing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => toggleTab("3")}
                >
                  Settings Keys
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "4" })}
                  onClick={() => toggleTab("4")}
                >
                  SMS Settings
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "5" })}
                  onClick={() => toggleTab("5")}
                >
                  Company & Bank
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "6" })}
                  onClick={() => toggleTab("6")}
                >
                  App Version
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="p-4">
              <TabPane tabId="1">
                <TableContainer
                  columns={policiesColumns}
                  data={settingsPolicies || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search Settings..."
                />
              </TabPane>
              <TabPane tabId="2">

                <TableContainer
                  columns={basicSettingsDetails}
                  data={settingsMore || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search Settings..."
                />

              </TabPane>
              <TabPane tabId="3">
                <TableContainer
                  columns={settingsKeyColumns}
                  data={settingsKey || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search Settings..."
                />
              </TabPane>
              <TabPane tabId="4">
                <div className="text-end mb-3">
                  <Button color="success" onClick={() => navigate("/settings/sms-setting/add")}>
                    <i className="ri-add-line align-bottom me-1"></i> Add SMS Setting
                  </Button>
                </div>
                <TableContainer
                  columns={smsSettingsColumns}
                  data={smsSettings || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search SMS Settings..."
                />
              </TabPane>
              <TabPane tabId="5">
                <TableContainer
                  columns={companySettingsColumns}
                  data={settingsMore || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search Company..."
                />
              </TabPane>
              <TabPane tabId="6">
                <TableContainer
                  columns={appVersionColumns}
                  data={appVersions || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  divClass="table-responsive table-card mb-3"
                  tableClass="align-top table-bordered align-top table-nowrap mb-0"
                  SearchPlaceholder="Search App Version..."
                />
              </TabPane>
            </TabContent>
          </Card>
          <ToastContainer closeButton={false} limit={1} />
        </Container>

        <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
          <ModalHeader toggle={toggleDeleteModal}>Confirm Delete</ModalHeader>
          <ModalBody>
            Are you sure you want to delete <strong>{settingsToDeleteName}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={confirmDeleteAction}>
              Delete
            </Button>{" "}
            <Button color="secondary" onClick={toggleDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Settings;